import React from 'react';

import { EmptySearchResults, Loading } from 'components';
import { useSubscribable } from 'utils/react';
import { getProtocolAssetsTabData } from 'api/selectors/pages';
import { useRouteUtils } from 'routes';
import { ProductSlug, VersionSlug, NetworkSlug } from 'domain/types';

import { AssetsTable } from './components';

export type AssetsProps = {
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
};

export function Assets({ network, productSlug, versionSlug }: AssetsProps) {
  const { redirectTo } = useRouteUtils();
  const dataRD = useSubscribable(
    () =>
      getProtocolAssetsTabData({
        network,
        productSlug,
        versionSlug,
        routeRedirectTo: redirectTo,
      }),
    [network, productSlug, versionSlug, redirectTo],
    { clientOnly: true },
  );

  return (
    <Loading data={dataRD}>
      {({ tableData, shouldRenderActionsColumn }) =>
        tableData.length > 0 ? (
          <AssetsTable shouldRenderActionsColumn={shouldRenderActionsColumn} data={tableData} />
        ) : (
          <EmptySearchResults />
        )
      }
    </Loading>
  );
}
